import { render, staticRenderFns } from "./FormulationApplicationsTab.vue?vue&type=template&id=39eb0ccf&"
import script from "./FormulationApplicationsTab.vue?vue&type=script&lang=js&"
export * from "./FormulationApplicationsTab.vue?vue&type=script&lang=js&"
import style0 from "./FormulationApplicationsTab.vue?vue&type=style&index=0&id=39eb0ccf&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports